import React from 'react'
import { Grid } from '@material-ui/core'
import { OnboardingJss } from '../styleJss'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import OnboardingDataForm from '../components/OnboardingDataForm/OnboardingDataForm'
import SideBanner from '../components/SideBanner/SideBanner'
import { CHILE, onBoardingDataInitStateCL, onBoardingDataInitStatePE } from '../../../constants'

const Onboarding = ({country}) => {
  const classes = OnboardingJss()
  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      className={classes.root}
    >
      <Header />
      <img style={{width: '100%'}} src={window.location.origin + '/onboarding/onboarding_top_image.png'} alt='ripley_images'/>
      <Grid container item sm={12} md={10}>
        <Grid container item sm={12} md={4}>
          <SideBanner country={country} />
        </Grid>
        <Grid container item sm={12} md={8}>
          <OnboardingDataForm onBoardingDataInitState={ country === CHILE.value ? onBoardingDataInitStateCL : onBoardingDataInitStatePE } />
        </Grid>
      </Grid>
      <Footer country={country}/>
    </Grid>
  )
}

export default Onboarding
